import { useQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { useState } from 'react';
import { useCrumbs } from '../../layout/crumbs';
import { projectsQuery } from '../../lib/projects';
import { EmptyState, ErrorBox, Spinner } from '../../ui/feedback';
import { Input } from '../../ui/form';
import { Page, PageHeader, Panel } from '../../ui/layout';

/**
 * «Бюджет и маржа» из меню: бюджет ведётся по проекту (вкладка проекта), поэтому здесь — выбор проекта и переход
 * к его бюджету, а не заглушка раздела. Суммы здесь не показываются: они — на вкладке по уровню денег.
 */
export function BudgetIndexPage() {
  useCrumbs([{ label: 'Бюджет и маржа' }]);
  const projects = useQuery(projectsQuery('active'));
  const [q, setQ] = useState('');
  const s = q.trim().toLowerCase();
  const rows = (projects.data ?? []).filter(
    (p) => !s || p.code.toLowerCase().includes(s) || p.name.toLowerCase().includes(s),
  );
  return (
    <Page>
      <PageHeader
        title="Бюджет и маржа"
        subtitle="Себестоимость по статьям, варианты исполнения, пять видов маржи, бюджет-график оплат и финансовый план. Бюджет ведётся по проекту — выберите проект."
      />
      <Panel title="Проекты">
        {projects.isPending ? (
          <Spinner />
        ) : projects.isError ? (
          <ErrorBox error={projects.error} />
        ) : (projects.data ?? []).length === 0 ? (
          <EmptyState title="Проектов пока нет">
            Бюджет появится, когда в портале будет проект со сметой.
          </EmptyState>
        ) : (
          <div className="flex flex-col gap-4">
            <Input
              aria-label="Поиск проекта"
              placeholder="Шифр или название проекта"
              value={q}
              onChange={(e) => setQ(e.target.value)}
            />
            <ul className="flex flex-col divide-y divide-line">
              {rows.map((p) => (
                <li key={p.id}>
                  <Link
                    to="/projects/$projectId/$tab"
                    params={{ projectId: p.id, tab: 'budget' }}
                    className="flex min-h-11 flex-wrap items-center gap-x-3 gap-y-1 py-2 text-[14px] text-ink hover:bg-tile/60"
                  >
                    <span className="num shrink-0 text-ink-2">{p.code}</span>
                    <span className="min-w-0 flex-1 break-words">{p.name}</span>
                    <span className="shrink-0 text-accent-text">Бюджет →</span>
                  </Link>
                </li>
              ))}
              {rows.length === 0 ? <li className="py-3 text-[14px] text-ink-2">Ничего не найдено</li> : null}
            </ul>
          </div>
        )}
      </Panel>
    </Page>
  );
}
